export enum ESanityFactory {
  PAGE_BUILDER = 'pageBuilder',
  PAGE_SLUG = 'pageSlug',
}
